/* eslint-disable @typescript-eslint/dot-notation */
import { Injectable } from '@angular/core';
import { LoggingModel } from '.';
import { LoggingDatabaseProvider } from './logging-database.provider';

@Injectable()
export class LoggingDatabaseRepository {
	public constructor(private loggingDatabaseProvider: LoggingDatabaseProvider) {}

	public async insert(model: LoggingModel): Promise<void> {
		const databaseInstance = this.loggingDatabaseProvider.getDatabase();
		const logsCollection = databaseInstance['logs'];
		try {
			await logsCollection.insert(model);
		} catch (error) {
			/* eslint-disable no-console */
			console.error('Could not insert log data');
		}
	}

	public async getAll(): Promise<LoggingModel[]> {
		const databaseInstance = this.loggingDatabaseProvider.getDatabase();
		const logsCollection = databaseInstance['logs'];

		return (await logsCollection.find().exec()).map((rxDoc) => rxDoc.toJSON());
	}
}
